import { ExternalLink } from "lucide-react";
import { useState } from "react";
import { useServiceEndpoints } from "../../../routes/overview/hooks/endpoints";
import NodeSpinner from "../common/node-spinner";

const EndpointToggle = ({ serviceName, serviceType, onViewAll }) => {
	const { endpointsByService, getEndpoints } = useServiceEndpoints();
	const data = endpointsByService[serviceName];
	const [loading, setLoading] = useState(false);

	const handleClick = async (e) => {
		e.stopPropagation();
		if (!data) {
			setLoading(true);
			await getEndpoints(serviceName);
			setLoading(false);
		}
		onViewAll();
	};

	const producerCount = data?.producer?.endpoints?.length || 0;
	const consumerCount = data?.consumer?.reduce((acc, s) => acc + (s.endpoints?.length || 0), 0) || 0;
	const totalCount = producerCount + consumerCount;

	const getLabel = () => {
		if (loading) {
			return (
				<span className="flex items-center gap-1.5">
					<NodeSpinner size={12} className="text-primary" />
					Loading endpoints
				</span>
			);
		}
		if (!data) {
			if (serviceType === "CONSUMER_PRODUCER") return "View endpoints";
			if (serviceType === "PRODUCER") return "View exposed endpoints";
			return "View consumed endpoints";
		}
		if (serviceType === "CONSUMER_PRODUCER") {
			return `${producerCount} exposed · ${consumerCount} consumed`;
		}
		if (serviceType === "PRODUCER") {
			return `${totalCount} exposed endpoint${totalCount !== 1 ? "s" : ""}`;
		}
		return `${totalCount} consumed endpoint${totalCount !== 1 ? "s" : ""}`;
	};

	return (
		<div className="border-t border-border/30">
			<button
				onClick={handleClick}
				disabled={loading}
				className="flex items-center w-full px-3 py-1.5 text-xs text-gray-400 hover:text-gray-200 transition-colors bg-transparent disabled:opacity-70"
			>
				{!loading && <ExternalLink className="w-3 h-3 mr-1.5 shrink-0" />}
				<span>{getLabel()}</span>
			</button>
		</div>
	);
};

export default EndpointToggle;
